import ImgFrankfurt from "../../assets/images/contact-us/frankfurt.png";
import ImgHongKong from "../../assets/images/contact-us/hongkong.png";
import ImgNewYork from "../../assets/images/contact-us/newyork.png";

export const HEADQUARTERS = [
  {
    id: "0",
    city: "Frankfurt",
    country: "Germany",
    address: "Mainzer Landstraße 51, Frankfurt, Hesse 60329, DE",
    image: ImgFrankfurt,
  },
  {
    id: "1",
    city: "New York",
    country: "United States",
    address: "28-07 Jackson Ave, 8th Fl, Long Island City, NY 11101",
    image: ImgNewYork,
  },
  {
    id: "2",
    city: "Hong Kong",
    country: "Hong Kong",
    address: "0F-130C, 4/F, 9 Queens Road Central, HK",
    image: ImgHongKong,
  },
];
